<script>
	import ProgressBar from './ProgressBar.svelte';

	let progress = 0;
	const interval = setInterval(() => {
		progress += 5;
		(progress >= 100) && clearInterval(interval);
	}, 300);

</script>

<main>
	<h1>Ma super application illustrative</h1>
	<ProgressBar progress="{progress}" />
</main>
